import {getBadgeColor} from '../../../../utils/badge'
import ProductBadgesTableActionsMenu from '../actions-menu/ProductBadgesTableActionsMenu'
import {Link} from 'react-router-dom'

const ProductBadgesTableRow = ({row: badge, actionOverlay, hasWritePermission}: any) => {
  return (
    <tr>
      <td>
        {hasWritePermission ? (
          <Link
            className='text-hover-primary cursor-pointer text-dark text-decoration-underline'
            to={`/products/product-badges/${badge.id}/${badge.displayName}`}
          >
            {badge?.name}
          </Link>
        ) : (
          <span>{badge?.name}</span>
        )}
      </td>
      <td>{badge?.displayName}</td>
      <td>{badge?.productCount}</td>
      <td className='text-capitalize'>
        <span className={`badge ${getBadgeColor(badge?.status, 'light')} badge-lg`}>
          {badge?.status}
        </span>
      </td>
      {hasWritePermission && actionOverlay(ProductBadgesTableActionsMenu)}
    </tr>
  )
}

export default ProductBadgesTableRow
